<template>
    <InputFields 
        v-bind="$attrs"
        :type="inputType"
        :right-icon="inputType === 'password' ? FaRegEye : FaRegEyeSlash"
        @icon-click="toggleInputType"
    />
</template>

<script lang="ts" setup>
import InputFields from "./InputFields.vue";
import { FaRegEye, FaRegEyeSlash } from "vue3-icons/fa6";
const inputType = ref<'password' | 'text'>('password')

const toggleInputType = () => {
    inputType.value = inputType.value === 'password' ? 'text' : 'password'
}
</script>